import api from "./axiosInstance";

export const getAllGameModes = () => {
  return api.get("/api/game");
};


export const createGameMode = (payload) => {
  return api.post("/api/game/new", payload);
};


export const deleteGameMode = (id) => {
  return api.delete(`/api/game/${id}`);
};
